import { takeLatest } from 'redux-saga/effects';
import apiCall, { GRATAFY_URL } from '../../utils/apiCall';
import {
  GET_THERMOSTAT,
  GET_THERMOSTATS,
  UPDATE_ECOBEE_THERMOSTAT,
  UPDATE_THERMOSTAT,
  UPDATE_THERMOSTAT_BULK,
  GET_BUILDING_THERMOSTAT_PRESETS,
  UPDATE_THERMOSTAT_HVAC_MODE,
  UPDATE_THERMOSTAT_HVAC_MODE_BULK,
  UPDATE_MASTER_THERMOSTAT_CONTROL,
  GET_MASTER_THERMOSTAT_CONTROL,
  UPDATE_BUILDING_THERMOSTAT_PRESETS,
  CREATE_THERMOSTAT_PRESET,
  ATTACH_THERMOSTAT_PRESET,
} from '../constants';

const searchThermostat = apiCall({
  type: GET_THERMOSTATS,
  method: 'GET',
  path: ({ orgID, buildingID, unitID, all, unitIds, suiteIds }) => {
    const searchParams = new URLSearchParams();
    searchParams.append('o', orgID);
    searchParams.append('b', buildingID);

    if (unitIds && unitIds.length > 0) {
      unitIds.forEach(id => {
        searchParams.append('u', id);
      });
    }

    if (suiteIds && suiteIds.length > 0) {
      suiteIds.forEach(id => {
        searchParams.append('s', id);
      });
    }

    if (unitID) {
      searchParams.append('u', unitID);
    }

    if (all) {
      searchParams.append('all', 'true');
    }

    return `/admin/device/thermostats?${searchParams.toString()}`;
  },
  gratafyURL: GRATAFY_URL
});

const updateThermostat = apiCall({
  type: UPDATE_THERMOSTAT,
  method: 'POST',
  path: () => `/admin/device/thermostats/temperature`,
  gratafyURL: GRATAFY_URL
});

const updateEcobeeThermostat = apiCall({
  type: UPDATE_ECOBEE_THERMOSTAT,
  method: 'POST',
  path: ({ ecobeeID }) => `/admin/device/thermostats/${ecobeeID}/hvacMode`,
  gratafyURL: GRATAFY_URL
});

const updateThermostatHvacMode = apiCall({
  type: UPDATE_THERMOSTAT_HVAC_MODE,
  method: 'POST',
  path: ({ thermostatId }) => `/admin/device/thermostats/${thermostatId}/hvacMode`,
  gratafyURL: GRATAFY_URL
});

const updateThermostatBulk = apiCall({
  type: UPDATE_THERMOSTAT_BULK,
  method: 'POST',
  path: () => `/admin/device/thermostats/temperature/bulk`,
  gratafyURL: GRATAFY_URL
});

const attachThermostatPreset = apiCall({
  type: ATTACH_THERMOSTAT_PRESET,
  method: 'PATCH',
  path: ({ presetId }) => `/admin/device/thermostats/attach-preset/${presetId}`,
  gratafyURL: GRATAFY_URL
});


const updateThermostatHvacModeBulk = apiCall({
  type: UPDATE_THERMOSTAT_HVAC_MODE_BULK,
  method: 'POST',
  path: () => `/admin/device/thermostats/hvacMode/bulk`,
  gratafyURL: GRATAFY_URL
});

const getThermostat = apiCall({
  type: GET_THERMOSTAT,
  method: 'GET',
  path: ({ deviceId }) => `/admin/device/thermostats/${deviceId}`,
  gratafyURL: GRATAFY_URL
});

const getBuildingThermostatPresets = apiCall({
  type: GET_BUILDING_THERMOSTAT_PRESETS,
  method: 'GET',
  path: ({ organizationId, buildingId }) => `/admin/device/org/${organizationId}/building/${buildingId}/thermostat-presets`,
  gratafyURL: GRATAFY_URL
});

const getMasterThermostatControl = apiCall({
  type: GET_MASTER_THERMOSTAT_CONTROL,
  method: 'GET',
  path: ({ organizationId, buildingId }) => `/admin/device/org/${organizationId}/building/${buildingId}/master-thermostat-control`,
  gratafyURL: GRATAFY_URL
});

const updateThermostatMasterControl = apiCall({
  type: UPDATE_MASTER_THERMOSTAT_CONTROL,
  method: 'PATCH',
  path: ({ organizationId, buildingId }) => `/admin/device/org/${organizationId}/building/${buildingId}/master-thermostat-control`,
  gratafyURL: GRATAFY_URL
});

const updateBuildingThermostatPresets = apiCall({
  type: UPDATE_BUILDING_THERMOSTAT_PRESETS,
  method: 'PATCH',
  path: ({ organizationId, buildingId }) => `/admin/device/org/${organizationId}/building/${buildingId}/thermostat-presets/update`,
  gratafyURL: GRATAFY_URL
});

const createThermostatPreset = apiCall({
  type: CREATE_THERMOSTAT_PRESET,
  method: 'POST',
  path: () => `/admin/device/thermostat-presets`,
  gratafyURL: GRATAFY_URL
});

export default function* thermostatSaga() {
  yield takeLatest(GET_THERMOSTAT, getThermostat);
  yield takeLatest(GET_THERMOSTATS, searchThermostat);
  yield takeLatest(UPDATE_THERMOSTAT, updateThermostat);
  yield takeLatest(UPDATE_ECOBEE_THERMOSTAT, updateEcobeeThermostat);
  yield takeLatest(UPDATE_THERMOSTAT_HVAC_MODE, updateThermostatHvacMode);
  yield takeLatest(ATTACH_THERMOSTAT_PRESET, attachThermostatPreset);
  yield takeLatest(UPDATE_THERMOSTAT_BULK, updateThermostatBulk);
  yield takeLatest(UPDATE_THERMOSTAT_HVAC_MODE_BULK, updateThermostatHvacModeBulk);
  yield takeLatest(GET_BUILDING_THERMOSTAT_PRESETS, getBuildingThermostatPresets);
  yield takeLatest(GET_MASTER_THERMOSTAT_CONTROL, getMasterThermostatControl);
  yield takeLatest(UPDATE_MASTER_THERMOSTAT_CONTROL, updateThermostatMasterControl);
  yield takeLatest(UPDATE_BUILDING_THERMOSTAT_PRESETS, updateBuildingThermostatPresets);
  yield takeLatest(CREATE_THERMOSTAT_PRESET, createThermostatPreset);
}
